import { render, staticRenderFns } from "./demand-cooperation-list.vue?vue&type=template&id=801df9c0&scoped=true&"
import script from "./demand-cooperation-list.vue?vue&type=script&lang=js&"
export * from "./demand-cooperation-list.vue?vue&type=script&lang=js&"
import style0 from "./demand-cooperation-list.vue?vue&type=style&index=0&id=801df9c0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "801df9c0",
  null
  
)

export default component.exports